import _Vue, { PluginObject } from 'vue';

import * as Components from './components';

export default {
  install: function install(Vue: typeof _Vue) {
    Object.keys(Components).forEach((key) => Vue.component(key, (Components as any)[key]));
  },
} as PluginObject<void>;
